import { jsx as n } from "react/jsx-runtime";
import { useMemo as m } from "react";
import { useChatbotContext as a } from "../../hooks/useChatbotContext.js";
import { useSimulateStream as c } from "../../hooks/useSimulateStream.js";
function k({
  children: r,
  simulateStream: t = !1,
  ...e
}) {
  const { Markdown: d, remarkGfm: o, rehypeHighlight: s, rehypeRaw: i } = a(), l = m(
    () => ({
      ...e,
      remarkPlugins: [o],
      rehypePlugins: [[s, { ignoreMissing: !0 }], i],
      components: {
        a: h,
        table: u,
        mark: f
      }
    }),
    [e, s, i, o]
  ), b = c(r, t);
  return /* @__PURE__ */ n(d, { ...l, children: b });
}
const f = ({ children: r, ...t }) => /* @__PURE__ */ n("mark", { ...t, className: "bg-accent text-accent-foreground", children: r }), h = ({ children: r, ...t }) => {
  const { cn: e, handleLinkClick: d } = a();
  return /* @__PURE__ */ n(
    "a",
    {
      ...t,
      target: "_blank",
      rel: "noreferrer noopener",
      className: e(
        "rounded-small bg-inherit text-inherit underline ring ring-transparent ring-offset-2 ring-offset-card transition hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-ring",
        t.className
      ),
      onClick: (o) => {
        d(o.currentTarget.href);
      },
      children: r
    }
  );
}, u = (r) => {
  const { cn: t } = a();
  return /* @__PURE__ */ n(
    "table",
    {
      ...r,
      className: t(
        "w-full border-separate border-spacing-0 [&_tbody>tr:last-of-type>td:first-of-type]:rounded-bl-medium [&_tbody>tr:last-of-type>td:last-of-type]:rounded-br-medium [&_td]:border-0 [&_td]:border-b [&_td]:border-l [&_td]:border-solid [&_td]:border-primary [&_td]:px-3 [&_td]:py-1 [&_td]:text-left [&_td]:last-of-type:border-r [&_th:first-of-type]:rounded-tl-medium [&_th:last-of-type]:rounded-tr-medium [&_th]:border-0 [&_th]:border-b [&_th]:border-l [&_th]:border-t [&_th]:border-solid [&_th]:border-primary [&_th]:bg-primary [&_th]:px-3 [&_th]:py-1 [&_th]:text-left [&_th]:font-semibold [&_th]:text-primary-foreground [&_th]:last-of-type:border-r [&_thead]:border-b [&_tr]:border-b",
        r.className
      )
    }
  );
};
export {
  k as BotMessageMarkdown
};
